<app-store-details-infos [store]="StoreDetailsInfos.FromMissionDetails(this.missionDetails)" />

<div id="mission_activity_infos">    
    
    @if(this.missionDetails.activitySelected){
        <marv-field label="{{'DATE' | translate}}" icon="calendar-outline" value="{{this.missionDetails.activitySelected.day | epochToString}}{{(this.missionDetails.activitySelected.amStartTime && this.missionDetails.activitySelected.pmEndTime ? ' | '+this.missionDetails.activitySelected.amStartTime+' - '+this.missionDetails.activitySelected.pmEndTime : (this.missionDetails.activitySelected.amStartTime ? ' | '+this.missionDetails.activitySelected.amStartTime : (this.missionDetails.activitySelected.pmEndTime ? ' | '+this.missionDetails.activitySelected.pmEndTime : '')))}}"/>
        <marv-field label="{{'DURATION' | translate}}" icon="time-outline" [value]="this.missionDetails.activitySelected.duration"/>
    }
    
    <marv-field label="{{'PLANNED_BY' | translate}}" icon="person-outline" [value]="this.missionDetails.plannedBy || '-'"/>
    
    <marv-field id="field_purposes" label="{{'VISIT_PURPOSES' | translate}}" icon="rocket-outline">        
        @if(this.missionDetails.purposes && this.missionDetails.purposes.length > 0){
            <div id="mission_activity_purposes">
                @for(purpose of this.missionDetails.purposes; track $index){
                    <div class="mission_activity_purpose" [class.fulfilled]="purpose.fulfilled">{{purpose.name}}</div>
                }
            </div>
        }
        @else{
            <b>-</b>
        }
    </marv-field>
            
</div>

<div id="mission_assignment">
    <marv-section-title label="{{'STATUS' | translate}}" icon="information-circle-outline"/>
         
    @if(this.missionDetails.cancellationRequest !== null){
        <marv-message type="warning">{{'MSG_CANCELLATION_REQUEST_PENDING' | translate}}</marv-message>
    }
        
    <div id="mission_assignment_content">
           
        <div id="mission_status">
            <div id="mission_status_icon">
                @if(this.missionDetails.activitySelected){
                    <ion-icon [name]="this.missionDetails.activitySelected.status.icon" [class]="this.missionDetails.activitySelected.status.color"></ion-icon>
                }
                @else{
                    <ion-icon [name]="this.missionDetails.status.icon" [class]="this.missionDetails.status.color"></ion-icon>
                }
            </div>
            <div id="mission_status_label">
                @if(this.missionDetails.activitySelected){
                    {{this.missionDetails.activitySelected.status.name | translate}}
                }
                @else{
                    {{this.missionDetails.status.name | translate}}
                }
            </div>
        </div>
        <marv-field label="{{'PROFIL_TYPE' | translate}}" icon="person-outline" [value]="this.missionDetails.profil || '-'"/>
        <marv-field label="{{'AGENT_AFFECTED' | translate}}" icon="person-outline">   
            <div id="mission_worker">                
                @if(this.worker){
                    @if(this.missionDetails.source === 'lgg'){
                        <span id="mission_worker_permanent" (click)="this.goToPermanentPlanning($event)">
                            <b>{{this.worker.name}}</b>
                            <ion-icon name="calendar-outline"></ion-icon>
                        </span>
                    }
                    @else{
                        @if(this.loggedUserService.loggedUser?.hierarchicalNature === environment.USER_PROFIL_SECTOR && this.showAgentAffected){
                            <b>{{this.worker.name}}</b>                        
                            @if(this.worker.phone){
                                <div id="mission_worker_contact">                   
                                    @if(this.worker.phone){
                                        <a [href]="'tel:'+this.worker.phone"><ion-icon name="call-outline"></ion-icon></a>
                                    }
                                </div>
                            }
                        }
                        @else{
                            <b>{{'PEOPLE_ASSIGNED' | translate}}</b>        
                        }
                    }
                    
                    @if(this.missionDetails.activitySelected && this.missionDetails.activitySelected.recoCompliance){
                         <div id="mission_reco">{{'RECO' | translate}}</div>
                    }       
                                        
                }
                @else{
                    <b>-</b>
                } 
            </div>            
            
        </marv-field>
                               
        @if(this.missionDetails.activitySelected && this.missionDetails.showPresenceCheckInfos){
            <div id="mission_presence">    
                @if(this.missionDetails.source === 'loga'){
                    @if(this.missionDetails.activitySelected?.presenceConfirmed){
                        <div class="green">
                            {{'PRESENCE_CONFIRMED' | translate}}
                            <ion-icon name="thumbs-up-outline"></ion-icon>
                        </div>
                    }
                    @else{
                        <div class="orange">
                            {{'PRESENCE_NOT_CONFIRMED' | translate}}
                            <ion-icon name="thumbs-down-outline" ></ion-icon>
                        </div>
                    }   
                }
                @if(this.missionDetails.activitySelected?.reportable){
                    @if(this.missionDetails.activitySelected?.reportingCompleted){
                        <div class="reporting_status green">
                            {{'REPORTING_COMPLETED' | translate}}
                            <ion-icon name="thumbs-up-outline"></ion-icon>

                            @if(this.isCraDisplayAllowed()){
                                <marv-button icon="open-outline" [rounded]="true"  size="small" [withMargin]="false" (click)="this.openCra()" /> 
                            }

                        </div>

                    }
                    @else{
                        <div class="reporting_status orange">
                            {{'REPORTING_NOT_COMPLETED' | translate}}
                            <ion-icon name="thumbs-down-outline" ></ion-icon>
                        </div>
                    }    
                }
            </div>
        }
        
    </div>
    
</div>

@if(this.missionDetails.source === 'loga'){
    <div id="mission_quotas">
        <marv-section-title label="{{'QUOTAS_ALLOCATION' | translate}}" icon="pie-chart-outline"/>
        @if(this.missionDetails.quotas.length > 0){
            <div id="mission_quotas_content">
                @for(quota of this.missionDetails.quotas; track $index){
                    <div class="mission_quota">
                        <div class="mission_quota_label">
                            <ion-icon name="cash-outline"></ion-icon> {{quota.name}}
                        </div>
                        <div class="mission_quota_sep"></div>
                        <div class="mission_quota_amount">{{quota.amount}}</div>
                    </div>
                }
            </div>
        }
        @else{
            <marv-message type="info">{{'MSG_NO_QUOTA' | translate}}</marv-message>
        }

    </div>

    <div id="mission_brief">
        <marv-section-title label="{{'MISSION_BRIEF' | translate}}" icon="information-circle-outline"/>

        <marv-field label="{{'MISSION_BRIEF' | translate}}" icon="information-circle-outline" [value]="this.missionDetails.briefMission?.details || '-'"/>
        <marv-field label="{{'MISSION_BRIEF_FILE' | translate}}" icon="document-outline" >
            <div id="mission_brief_file">
                @if(this.missionDetails.briefMission?.file){
                    <div id="mission_brief_file_link" (click)="this.downloadBriefMission()">
                        <ion-icon name="download-outline"></ion-icon>
                        {{'DOWNLOAD_FILE' | translate}}
                    </div>
                }
                @else{
                    <b>-</b>
                }
            </div>
        </marv-field>
        <marv-field label="{{'MISSION_SUGGESTION' | translate}}" icon="information-circle-outline" [value]="this.missionDetails.comment || '-'"/>

    </div>

    <div id="mission_store_contact">
        <marv-section-title label="{{'STORE_CONTACT_INFOS' | translate}}" icon="information-circle-outline"/>

        <marv-field label="{{'CONTACT' | translate}}" icon="person-outline" [value]="this.missionDetails.storeContact?.name || '-'"/>
        <marv-field label="{{'STORE_ACCESS' | translate}}" icon="location-outline" [value]="this.missionDetails.storeContact?.access || '-'"/>

    </div>

    <div id="mission_customer_appointment">
        <marv-section-title label="{{'CUSTOMER_APPOINTMENT' | translate}}" icon="person-outline"/>

        <marv-field label="{{'APPOINTMENT_PLACE' | translate}}" icon="location-outline" [value]="this.missionDetails.customerAppointment?.place || '-'"/>
        <marv-field label="{{'APPOINTMENT_HOUR' | translate}}" icon="time-outline" [value]="this.missionDetails.customerAppointment?.time || '-'"/>

    </div>
}

@if(this.missionDetails.source === 'lgg'){
    <div id="mission_planning_instructions">
        <marv-section-title label="{{'PLANNING_INSTRUCTIONS' | translate}}" icon="book-outline"/>
        @if(this.missionDetails.planningInstructions.length > 0){
            <div id="mission_planning_instructions_list">
                @for(instruction of this.missionDetails.planningInstructions; track $index){
                    <marv-sub-item>
                        <div class="instruction_name" (click)="instruction.open = !instruction.open">
                            <div>{{instruction.name}}</div>        
                            @if(this.showBtnEditStoreCheck){
                                <ion-icon name="settings" class="btn_questionnaire" (click)="this.openStoreCheckQuestionnaire($event, instruction.id)"></ion-icon>
                            }
                            <ion-icon [name]="(instruction.open ? 'chevron-up-outline' : 'chevron-down-outline')" ></ion-icon>                           
                        </div>
                        <div class="instruction_groups" [class.open]="instruction.open">
                            @for(group of instruction.groups; track $index){
                                <div class="instruction_group">
                                    <div class="group_name">{{group.name}}</div>
                                    <div class="group_fields">
                                        @for(field of group.fields; track $index){
                                            @if(field.value !== ''){
                                                <div class="field">
                                                    <div class="field_name">{{field.name}}</div>
                                                    <div class="field_value">
                                                        @if(field.type === 'PHOTO'){
                                                            <ion-thumbnail>
                                                                <img [src]="field.value" />
                                                            </ion-thumbnail>
                                                        }
                                                        @else{
                                                            <div>{{field.value}}</div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </marv-sub-item>
                }
            </div>
        }
        @else{
            <marv-message type="info">{{'MSG_NO_PLANNING_INSTRUCTION' | translate}}</marv-message>
        }
    </div>

    <div id="mission_planning_objectives_reports">
        <div id="mission_planning_objectives_reports_title">
            <marv-section-title label="{{'PLANNING_OBJECTIVES_REPORTS' | translate}}" icon="rocket-outline"/>
            @if(this.missionDetails.purposes.length > 1){
                <marv-button icon="download-outline" [rounded]="true" [isFetching]="this.isFetchingDownload === -1" size="small" (click)="this.downloadAllObjectivesReports()" /> 
            }
        </div>
        @if(this.missionDetails.purposes.length > 0){            
            <div id="mission_planning_objectives_reports_list">
                @for(purpose of this.missionDetails.purposes; track $index){
                    <marv-sub-item>
                        <div class="objective_report" (click)="this.downloadObjectiveReport(purpose.id, purpose.name)">
                            <div>{{purpose.name}}</div>
                            @if(this.isFetchingDownload === purpose.id || this.isFetchingDownload === -1){
                                <ion-spinner></ion-spinner>
                            }
                            @else{
                                <ion-icon name="download-outline"></ion-icon>
                            }
                        </div>
                    </marv-sub-item>
                }
            </div>
        }
        @else{
            <marv-message type="info">{{'MSG_NO_PLANNING_OBJECTIVES_REPORTS' | translate}}</marv-message>
        }
    </div>
}

<marv-drawer #drawerPermanentStoreCheckQuestionnaire (onDidDismiss)="this.onDidDismissDrawerPermanentStoreCheckQuestionnaire($event)"> 
    @if(this.missionDetails && this.storeCheckObjectiveId){
        <app-permanent-planning-questionnaire            
            [operationId]="this.missionDetails.operation.id"
            [storeCheckId]="this.missionDetails.missionId"
            [objectiveId]="this.storeCheckObjectiveId"
            [displayAll]="false"
            (onChangeQuestionnaire)="this.onChangeQuestionnaire($event)"
            />
    }
</marv-drawer>